export const SUPPORTED_FILE_TYPES = [
  "application/pdf", //pdf
  "image/jpeg", //jpeg/jpg
  "image/png", //png
  "application/msword", //doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //docx
  "font/ttf", //tiff
];

export type CategorizedFiles = {
  supportedFiles: File[];
  unsupportedFiles: File[];
  emptyFiles: File[];
};

export function categorizeFiles(files: File[]): CategorizedFiles {
  const supportedFiles: File[] = [];
  const unsupportedFiles: File[] = [];
  const emptyFiles: File[] = [];

  files.forEach((file) => {
    // Check size first so a 0-byte file surfaces the causal "empty" message
    // (e.g. a cloud placeholder that never finished downloading) rather than
    // a misleading "unsupported extension" error.
    if (file.size === 0) {
      emptyFiles.push(file);
    } else if (SUPPORTED_FILE_TYPES.includes(file.type)) {
      supportedFiles.push(file);
    } else {
      unsupportedFiles.push(file);
    }
  });

  return { supportedFiles, unsupportedFiles, emptyFiles };
}
